import React from 'react'
import { OnSchedUtils } from '../../../../../../utils';
import Weekday from './Weekday/Weekday';


const WeeklyAllocations = ({ element, weeklyAllocations, newBlock, repeats }) => {
  const [weekdaysValue, setWeekdaysValue] = React.useState("");
  const weekdays = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

  const selectDay = day => {
    const dayIdx = weekdays.indexOf(day);
    if (weekdaysValue.includes(dayIdx)) {
      setWeekdaysValue(weekdaysValue.replace(dayIdx, ''));
    }
    else {
      setWeekdaysValue(weekdaysValue + dayIdx);
    }
  }

  if (!weeklyAllocations || !newBlock || !repeats) return null

  return (
    <div className='WeeklyAllocations'>
      <input type="hidden" value={weekdaysValue} name="weekdays" />
      { weekdays.map(day => <Weekday key={day} element={element} selectDay={selectDay} day={day} />) }
    </div>
  )
}

export default WeeklyAllocations